// Header.jsx
import logo from "../../img/vect.svg";
import React from "react";

export const Header = () => {
  return (
    <div className="header">
      <div className="logo">
        <img src={logo} alt="logo" />
      </div>
      <h1>SIL Gestión</h1>
    </div>
  );
};
